// ─────────────────────────────────────────────
// TypingIndicator
// Shown inside the assistant message bubble
// while tokens are streaming in.
// Three dots pulse in sequence — left to right.
// ─────────────────────────────────────────────

export function TypingIndicator() {
  return (
    <div className="flex items-center gap-1 px-1 py-1">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="
            w-2 h-2 rounded-full
            bg-[var(--color-text-sub)]
            animate-bounce
          "
          style={{ animationDelay: `${i * 0.15}s` }}
        />
      ))}
    </div>
  )
}